/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


module.exports = function ( app ) {
    var ts       = require('../ts')(app),
        gettext  = require('mag-gettext').gettext;

    return {
        id: 'timeShiftLength',
        name: gettext('Duration'),
        description: gettext('Set the TimeShift recording duration'),
        icon: 'theme-icon-clock',
        data: {
            timeShiftLength: 3600
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            var data = require('../data/ts.length');

            data.forEach(function ( item ) {
                item.selected = item.value === currentValue.timeShiftLength;
            });

            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.data.timeShiftLength = value;

            ts.length = value;
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'timeshift'
    };
};
